import layers from './layers';
import modals from './modals';
import notifications from './notifications';

export default {
    layers,
    modals,
    notifications
}